import {LoginResponse} from '../types';

export async function NoneHandler(value: LoginResponse): Promise<void> {
}
